import { cn } from '~utils/cn'

import Icon from '~components/ui/icon'
import type { IconProps } from '~components/ui/icon/types'

const DialogIcon = ({ name, className, ...props }: IconProps) => {
  return <Icon {...props} name={name} className={cn('mb-4 h-12 w-12 lg:mb-6', className)} />
}

export default DialogIcon
